import { makeStyles } from "@material-ui/core";
import { Autocomplete, TextField } from "@mui/material";
import { useEffect } from "react";
import classes from "../CustomInputs.module.css";

const useStyles = makeStyles({
  option: {
    background: "white !important",
    "&:hover": {
      background: "rgb(245,245,245) !important"
    }
  }
});

const SearchAutocompleteInput = (props) => {
  const styles = useStyles();

  useEffect(() => {
    if (props.handleError) {
      props.handleError({ [props.id]: props.hasError });
    }
  }, [props.value]);

  return (
    <div className={classes.customTextField}>
      <Autocomplete
        disableClearable
        disablePortal
        value={props.value}
        isOptionEqualToValue={(option, value) => option.key === value.key}
        // onChange={(event, newValue) => {
        //   props.onChange({ [props.id]: newValue?.label });
        // }}
        //onChange={props.onChange()}
        onChange={(event, newValue) => {
          props.onChange({ [props.id]: newValue.value });
        }}
        id="searchautocompleteInput"
        options={props.list}
        className={classes.textField}
        renderInput={(params) => {
          return (
            <TextField
              {...params}
              error={props.isStepSubmitted && props.hasError}
              helperText={
                props.isStepSubmitted && props.hasError ? props.errorMessage : ""
              }
              InputLabelProps={{ ...params.InputLabelProps, shrink: true }}
              InputProps={{
                ...params.InputProps,
                startAdornment: props.startAdornment
              }}
              label={props.label}
              FormHelperTextProps={{
                classes: {
                  error: classes.error,
                },
              }}
            />
          );
        }}
        classes={{
          option: styles.option,
          inputRoot: classes.filed,
          paper: classes.menuPaper,
          listbox: classes.listbox
        }}
      />
    </div>
  );
};

export default SearchAutocompleteInput;
